<script setup lang="ts">
import { useEventClock } from '@desktop/views/Relation/Sports/composables'

import EventClockInput from './EventClockInput.vue'

// composables
const {
  updateTimerSecond,
  stopTimer,
  startTimer,
  isClockRunning,
  eventTime,
  isValidEventClockTime,
  currentPeriodLengthMinutes,
} = useEventClock()

// methods
function onUpdate(
  newValue: string,
  oldValue: string,
  callback: (currentValue: string) => void,
): void {
  const value = parseInt(newValue)

  if (
    value >= 0 &&
    value <= 59 &&
    isValidEventClockTime({
      minute: eventTime.value.minute,
      second: value,
      periodLengthMinutes: currentPeriodLengthMinutes.value,
    })
  ) {
    updateTimerSecond(value)
    callback(newValue)
  } else {
    // if value is invalid, revert to old value
    callback(oldValue)

    // we need to start timer again because it was stopped for editing input of seconds
    if (isClockRunning.value) {
      startTimer()
    }
  }
}
</script>

<template>
  <EventClockInput
    type="second"
    :maxlength="2"
    data-testid="event-clock-second-input"
    @update="onUpdate"
    @focus="stopTimer"
  />
  <!-- timer must be stopped on focus, to prevent changing value in <EventClockMinute> when seconds changes minutes -->
</template>
